import { FormArray, ValidationErrors } from '@angular/forms';

export function ArrayMaxLengthValidator(maxLength: number) {
    return function(formArray: FormArray): ValidationErrors | null {
      return formArray.length > maxLength ?  { arrayMaxLength: true } : null;
    };
};